import React from 'react';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { observer } from 'mobx-react';

const FieldsConfig = () => {
    const fieldObj:any = CQMasterDataStore.Details.selectedFieldDetailsObject;
    
    return (
        <>
            <h2 className="slds-text-heading_small slds-m-bottom_medium">Fields Configuration</h2>
            <dl className="slds-dl_horizontal slds-m-bottom_medium">
                <dt className="slds-dl_horizontal__label">Type:</dt>
                <dd className="slds-dl_horizontal__detail">{fieldObj.type}</dd>
                <dt className="slds-dl_horizontal__label">Label:</dt>
                <dd className="slds-dl_horizontal__detail">{fieldObj.label}</dd>
                <dt className="slds-dl_horizontal__label">API Name:</dt>
                <dd className="slds-dl_horizontal__detail">{fieldObj.fullName}</dd>
            </dl>
        </>
    );
};

export const FieldsConfigInformation = observer(FieldsConfig);